// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-initiatives-js": function componentSrcPagesInitiativesJs() {
    return import("./../../src/pages/initiatives.js"
    /* webpackChunkName: "component---src-pages-initiatives-js" */
    );
  },
  "component---src-pages-pricing-js": function componentSrcPagesPricingJs() {
    return import("./../../src/pages/pricing.js"
    /* webpackChunkName: "component---src-pages-pricing-js" */
    );
  },
  "component---src-pages-side-projects-js": function componentSrcPagesSideProjectsJs() {
    return import("./../../src/pages/side_projects.js"
    /* webpackChunkName: "component---src-pages-side-projects-js" */
    );
  },
  "component---src-pages-software-js": function componentSrcPagesSoftwareJs() {
    return import("./../../src/pages/software.js"
    /* webpackChunkName: "component---src-pages-software-js" */
    );
  }
};